import { useTranslation as useT } from 'react-i18next'
import { useContext, useEffect, useState } from 'react'
import useKeyPress from './common/hooks/useKeyPress'
import { useLocalStorage } from './common/hooks/useLocalStorage'
import { useIsMounted } from './common/hooks/useIsMounted'
import i18next from 'i18next'
import { useTranslationApi as useTranslationApi } from './common/api-context'
import { GlobalContext } from './common/global-context'
import { LanguageKey, removeFalsyValues, getLangDynamically } from '@ringo/shared'

export function useI18n() {
    const { i18n } = useT()
    const [ciMode, setCiMode] = useState(false)
    const { getItem } = useLocalStorage()
    const isMounted = useIsMounted()
    const translationApi = useTranslationApi()
    const { loadedTranslations, setLoadedTranslations } = useContext(GlobalContext)
    const [lang, setLang] = useState<LanguageKey>(() => (getItem('lang') || 'de') as LanguageKey)

    useKeyPress({ metaKey: true, shiftKey: true, key: 'b' }, () => {
        setCiMode((val) => !val)
    })

    useEffect(() => {
        loadTranslations(lang).then((_) => i18n.changeLanguage(lang))
    }, [lang])

    const changeLanguage = (newLang: LanguageKey) => {
        setLang(newLang)
    }

    const loadTranslations = async (newLang: LanguageKey) => {
        try {
            if (!translationApi) {
                return
            }
            if (loadedTranslations.includes(newLang)) {
                return
            }
            const response = await translationApi.getTranslationByLanguage(newLang.toUpperCase() as any)
            let translations: object = (await response.data) as any
            translations = removeFalsyValues(translations)

            var inCodeTranslations: object = await getLangDynamically(lang)
            translations = { ...inCodeTranslations, ...translations }

            i18next.addResources(newLang, 'translation', translations)
            setLoadedTranslations((x) => [...x, newLang])
        } catch (error) {
            console.error('Failed to load translations:', error)
        }
    }

    useEffect(() => {
        if (!isMounted) {
            return
        }

        if (ciMode) {
            i18n.changeLanguage('cimode')
        } else {
            i18n.changeLanguage(getItem('lang')! || 'de')
        }
    }, [ciMode])

    return { lang, ...i18n, changeLanguage, ciMode }
}
